export default "__VITE_ASSET__e238e503__"